module.exports = __webpack_public_path__ + "static/welcome-bg-7be929afcd1a63a325ebaa473984c83a.svg";